export const narrow = (el) => <div style={{ maxWidth: 640, margin: '0 auto' }}>{el}</div>;
